import { useContext } from "react";
import { AppDependenciesContext } from "../providers/AppDependenciesProvider";

export const useDependencies = () => {
  return useContext(AppDependenciesContext);
};
